'use strict';
import $ from 'jquery';
import select2 from 'select2';
select2($);

/**
 * Custom multiselects
 */
const customSelect = {

  cacheDom: function() {
    this.$multiselect = $('.js-multiselect');
  },

  init: function() {

    // Add jQuery variables
    this.cacheDom();

    const multiselectOptions = {
      minimumResultsForSearch: -1,
      dropdownAutoWidth: true,
      templateResult: this._getOptions,
      templateSelection: this._getOptions,
      closeOnSelect: false,
      width: '100%'
    };

    this.$multiselect.each((index, element) => {
      $(element).select2(multiselectOptions);
    });

    // Bind event handlers
    this.bindEvents();
  },


  bindEvents: function() {
    this.$multiselect.on('change', this._updateTypeText);

    // Trigger once on init
    this.$multiselect.change();
  },

  /**
   * Counts the amount of selections and displays it in select
   */
  _updateTypeText: function() {
    let countText = '';

    const $select2 = $(this).next('.select2');
    const count = $(this).find(':selected').length;

    if(count === 0) {
      countText = window.TRANSLATIONS['search__type_all'];
    } else if(count === 1) {
      countText = count + ' ' + window.TRANSLATIONS['search__type_selected_one'];
    } else if(count > 1) {
      countText = count + ' ' + window.TRANSLATIONS['search__type_selected_n'];
    }

    $select2.find('.select2-search--inline').html(countText);
  },

  /**
   * Format option for select2. This is where the icon is added to the list.
   *
   * @param {Object} state The option object. state.element is the <option> element.
   * @returns {mixed} The content for the select2 option. Might be just a string, or a jQuery element.
   */
  _getOptions: function(state) {
    if(!state.id) {
      return state.text;
    }

    let optionHtml = '<div>' + state.text + '</div>';

    const icon = state.element.getAttribute('data-icon');

    if(icon) {
      optionHtml += '<img src="' + icon + '" />';
    }

    var $state = $(optionHtml);
    return $state;
  },

};

module.exports = customSelect;
